// Redux & Action
import { useSelector } from 'react-redux';

// @Utility
import currencyFormat from "@utility/numbers/currencyFormat";

// Component
import Grid from '@mui/material/Grid';
import ReloadBlance from "views/components/ReloadBlance";
import ImageShow from "views/components/ImageShow";

// Style & CSS
import "assets/css/Credit.css";

export default function Credit({ width }) {
    const homeData = useSelector(state => state.reduxHome.result);

    return (
        <div className="narbarCredit center" style={width !== null && { width: `${width}%` }}>
            <Grid container spacing={1} alignItems="center" justifyContent="center">
                <Grid item xs={3} md={3}>
                    <ImageShow className="coinSize" src="/images/icon/coin.webp" alt="เครดิต สล็อตออนไลน์"></ImageShow>
                </Grid>
                <Grid item xs={9} md={9}>
                    <Grid container alignItems="center">
                        <Grid item xs={9} md={9}>
                            <div className="textCredit">
                                {
                                    homeData !== null ? currencyFormat(homeData.balance, 2) : 0.00
                                }
                            </div>
                        </Grid>
                        <Grid item xs={3} md={3}>
                            <ReloadBlance homeData={homeData} style={{ color: "white" }}></ReloadBlance>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
}